export const CMS_TOUR_STORAGE_KEYS = {
  DASHBOARD: 'lureo_cms_dashboard_tour_completed',
  PROJECT: 'lureo_cms_project_tour_completed'
} as const;
